import styled from 'styled-components';

export const CreatedOnCellWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
